import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import DataTable from '../../../shared/tables/DataTable';
import './StoresPage.scss';
import { storeListSelectorSaga } from '../../../redux/saga/storePageSelectors';
import { useSelector, useDispatch } from 'react-redux';
import CustomPagination from '../../../shared/pagination/CustomPagination';
import { STORES_LIST_COLUMNS, TABLE_NAME, TABLE_SUBTITLE, STORES_PAGE_PLACEHOLDER } from '../../../constants/storesPageConstants';
import { getSingleStoreDetailsRequest } from '../../../redux/actions/storeActions';
import { handleSortingInTable } from '../../../shared/utils/format.helpers';
import { useMerchant } from '../../../MerchantContext';


export default function StoresPage() {

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { merchantId, setMerchantId } = useMerchant();
	const [searchTerm, setSearchTerm] = useState('');
	const wholeList = useSelector(storeListSelectorSaga);
	let filteredData = [];
	if (wholeList && wholeList.msg != 'ERROR') {
		filteredData = wholeList.filter(row =>
			row.sourceId.toString().toLowerCase().includes(searchTerm.toLowerCase())
		);
	}
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalPages, setTotalPages] = useState(0);
	const [sortConfig, setSortConfig] = useState({ key: 'sourceId', direction: 'Ascending' });
	const sortData = (data, { key, direction }) => {
		const dataToSort = [...data];
		return dataToSort.sort((a, b) => {
		  if (a[key] < b[key]) return direction === 'Ascending' ? -1 : 1;
		  if (a[key] > b[key]) return direction === 'Ascending' ? 1 : -1;
		  return 0;
		});
	};
	  
	const sortedAndFilteredData = sortData(filteredData, sortConfig);
	const indexOfLastRow = (currentPage + 1) * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage;
	const updatedRows = sortedAndFilteredData.slice(indexOfFirstRow, indexOfLastRow);

	const handleStorePageSort = (columnKey) => {
		handleSortingInTable(columnKey, sortConfig, setSortConfig );
	};

	const onPageChange = (newPage) => {
		setCurrentPage(newPage);
	  };
	  
	const onRowsPerPageChange = (newRowsPerPage) => {
		setRowsPerPage(newRowsPerPage);
		setCurrentPage(0);
	};

	useEffect(() => {
		setCurrentPage(0);
	}, [searchTerm]);

	useEffect(() => {
		const newTotalPages = Math.ceil(filteredData.length / rowsPerPage);
		setTotalPages(newTotalPages);
	}, [filteredData.length, rowsPerPage]);

	const handleStoresClick = (rowData, columnKey) => {
		//console.log('clicked', rowData, columnKey);
		dispatch(getSingleStoreDetailsRequest(merchantId, rowData.storeUuid, rowData.sourceId));
		navigate(`/dashboard/stores/singlestoreview/${rowData.storeUuid}`,{
			state: {
				merchantId: merchantId, 
				storeUuid: rowData.storeUuid,
				pathname: 'store',
				hamBurger: true,
				selectedIndex: 1

			}
		});
	  };
    
  return (
    <>

		<div className='store-container'>
			<Paper className='store-container--page-header'>
				<h4 className='store-container--title' data-testid='stores-title'>Stores</h4>
			</Paper>
		</div>

		<div className='store-page'>
			<div className='data-table'>
				<DataTable
					columns={STORES_LIST_COLUMNS}
					data={updatedRows}
					tableName={TABLE_NAME}
					tableSubTitle={TABLE_SUBTITLE}
					searchplaceholder={STORES_PAGE_PLACEHOLDER}
					includeCheckbox= {false}
					showAddToList={false}
					onSearch={(searchTerm) => {
						setSearchTerm(searchTerm);
						setCurrentPage(0);
					}}
					sortConfig={sortConfig}
					onSort={handleStorePageSort}
					clickableColumnKey='name'
					onCellClick={handleStoresClick}
					excludeColumnKey={['name', 'sourceId', ]}
				/>
				<CustomPagination
					totalNumberOfPages={totalPages}
					currentPageNumber={currentPage}
					rowsPerPage={rowsPerPage}
					onPageChange={(event, newPage) => onPageChange(newPage)}
					onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
					rowsPerPageOptions={[10,20,50]}
				/>
			</div>
		</div>
	</>
  );
}
